<template>
  <div class="display">
    <div class="f-tar">
      <Button @click="$router.push('/host/index/audit/list')">返回</Button>
    </div>
    <div v-if="info && info.length">
      <div v-for="(item, index) in info" :key="'contact-' + index">
        <div class="item">
          <div class="item-l">提交时间：</div>
          <div class="item-r">{{ item.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
        </div>
        <div class="item">
          <div class="item-l">审核状态：</div>
          <div class="item-r">
            <span v-if="item.status === 0" style="color: red;">尚未审核</span>
            <span v-if="item.status === 1" style="color: blue;">审核通过</span>
            <span v-if="item.status === -1" style="color: red;">审核未通过</span>
          </div>
        </div>
        <div class="item">
          <div class="item-l">联系人：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.contactName !== item.contactName)}"
          >{{ item.vehicleDown.contactName || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">联系电话：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.contactPhone !== item.contactPhone)}"
          >{{ item.vehicleDown.contactPhone || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">邮寄地址：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.address !== item.address)}"
          >{{ item.vehicleDown.address || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">邮政编码：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.postcode !== item.postcode)}"
          >{{ item.vehicleDown.postcode || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">车牌号：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.number !== item.number)}"
          >{{ item.vehicleDown.number || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">车辆吨位：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.tonnage !== item.tonnage)}"
          >{{ item.vehicleDown.tonnage || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">抵达时间：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.auditTime !== item.auditTime)}"
          >
            <span v-if="item.auditTime">{{ item.vehicleDown.auditTime | moment("YYYY/MM/DD HH:mm:ss")}}</span>
            <span v-else>N/A</span>
          </div>
        </div>  
        <div class="item">
          <div class="item-l">司机姓名：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.driverName !== item.driverName)}"
          >{{ item.vehicleDown.driverName || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">司机电话：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.driverPhone !== item.driverPhone)}"
          >{{ item.vehicleDown.driverPhone || 'N/A'}}</div>
        </div> 
        <div class="item">
          <div class="item-l">备注：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.vehicleDown && item.vehicleDown.remark !== item.remark)}"
          >{{ item.vehicleDown.remark || 'N/A'}}</div>
        </div> 
        <div class="f-tac" v-if="item && item.status !== 1">
          <Button @click="pass(item)" style="margin: 0 10px;" type="primary">通过审核</Button>
          <Button @click="unpass(item)" style="margin: 0 10px;" type="primary">不通过</Button>
        </div>
        <div class="f-tac" v-if="item && (item.status === 1 && item.syncStatus === 2)">
          <Button @click="asyncHandle">重新同步</Button>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "host-audit-info-car",
  data() {
    return {
      query: null,
      info: null,
      info2: null
    };
  },
  created() {
    this.query = this.$route.query;
    this.init();
  },
  computed: {
    cityBool() {
      let bool = false;
      if (this.info && this.info.vehicleDown) {
        const cityStr = this.info.province + this.info.city + this.info.county;
        const cityStr2 =
          this.info.vehicleDown.province +
          this.info.vehicleDown.city +
          this.info.vehicleDown.county;
        if (cityStr !== cityStr2) {
          bool = true;
        }
      }
      return bool;
    }
  },
  methods: {
    ...mapActions({
      getVehicleDownByRecord: "hostAuditModule/getVehicleDownByRecord",
      editVehicleDownAudit: "hostAuditModule/editVehicleDownAudit",
      reSync: "hostAuditModule/reSync"
    }),
    async init() {
      this.info = await this.getVehicleDownByRecord(this.$route.query.id);
      
    },
    async pass(item) {
      // 通过审核
      const opt = {
        id: item.id,
        status: 1
      };
      const bool = await this.editVehicleDownAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async unpass(item) {
      // 不通过审核
      const opt = {
        id: item.id,
        status: -1
      };
      const bool = await this.editVehicleDownAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async asyncHandle() {
      // 重新同步
      const bool = await this.reSync({ exchangeId: this.info.exchangeId });
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.display {
  padding: 20px 40px 40px;
  font-size: 14px;
  background: #fff;
  margin: 30px;
  color: #333;
  min-width: 800px;
  mim-height: 500px;
  .item {
    display: flex;
    margin-bottom: 18px;
    &-l {
      width: 200px;
      text-align: right;
    }
    &-r {
      flex: 1;
    }
  }
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
.editMode {
  color: red !important;
}
.edit {
  border-color: red !important;
}
.line {
  height: 1px;
  background: #ccc;
  margin: 20px 0;
}
</style>
